import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PanierState } from '../models';
import { PanierService } from './panier.service';

@Injectable({ providedIn: 'root' })
export class PaymentIframeGuard implements CanActivate {
  constructor(
    private panierService: PanierService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cartState = this.panierService.getCartState();
    if (cartState !== PanierState.PAY_IN_PROGRESS) {
      this.router.navigate(['/balance-outstanding']);
    }
    return cartState === PanierState.PAY_IN_PROGRESS;
  }
}
